import React, { Dispatch, SetStateAction, useContext } from "react";
import { useIntl } from "react-intl";
import CustomInput, {
  CustomInputLabel,
} from "src/app/components/CustomInput/CustomInput";
import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import { CustomTextareaLabel } from "src/app/components/CustomTextarea/CustomTextarea";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { PopupCol, PopupRow } from "src/app/components/PopUp";
import { PopupSection } from "src/app/components/PopUp/components/PopupSection";
import { TextBoxWrapper } from "src/app/components/TextBoxWrapper/TextBoxWrapper";
import { translateMessage } from "src/app/methods/translateMessage";
import { formTypeOptions } from "../CreateFormModal";
import { AccessLinkFieldContext } from "../../AccessLinkField";

interface Props {
  caption: string;
  setCaption: Dispatch<SetStateAction<string>>;
  description: string;
  setDescription: Dispatch<SetStateAction<string>>;
  successMessage: string;
  setSuccessMessage: Dispatch<SetStateAction<string>>;
  type: string;
  setType: Dispatch<SetStateAction<string>>;
  isContent: boolean;
}

export const CreateFormGeneral = (props: Props) => {
  const {
    caption,
    setCaption,
    description,
    setDescription,
    successMessage,
    setSuccessMessage,
    type,
    setType,
    isContent,
  } = props;

  const { accessLinkData } = useContext(AccessLinkFieldContext);

  const intl = useIntl();

  return (
    <PopupSection>
      {isContent && (
        <PopupRow className="details-popup__area-wrap">
          <PopupCol>
            <CustomInputLabel>
              <IDHFormattedMessage id="ws_type" defaultMessage="Type" />
            </CustomInputLabel>

            <CustomSelect
              value={type}
              onChange={setType}
              options={formTypeOptions}
              placeholder={translateMessage({
                intl,
                id: "ws_enter_form_description",
                defaultMessage: "Enter form description",
              })}
              disabled={accessLinkData.editMode}
            />
          </PopupCol>
        </PopupRow>
      )}

      <PopupRow>
        <PopupCol>
          <CustomInputLabel htmlFor="details-title">
            <IDHFormattedMessage id="ws_title" defaultMessage="Title" />
          </CustomInputLabel>
          <CustomInput
            id="details-title"
            type="text"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            placeholder={translateMessage({
              intl,
              id: "ws_enter_form_title",
              defaultMessage: "Enter form title",
            })}
            fullWidth
          />
        </PopupCol>
      </PopupRow>
      <PopupRow className="details-popup__area-wrap">
        <PopupCol>
          <CustomTextareaLabel
            htmlFor="details-popup__description"
            text={
              <IDHFormattedMessage
                id="ws_description"
                defaultMessage="Description"
              />
            }
          />

          <TextBoxWrapper
            id="details-popup__description"
            className="details-popup__description"
            value={description || ""}
            onChange={setDescription}
            placeholder={translateMessage({
              intl,
              id: "ws_enter_form_description",
              defaultMessage: "Enter form description",
            })}
          />
        </PopupCol>
      </PopupRow>

      <PopupRow className="details-popup__area-wrap">
        <PopupCol>
          <CustomTextareaLabel
            htmlFor="details-popup__success-message"
            text={
              <IDHFormattedMessage
                id="ws_success_message"
                defaultMessage="Success message"
              />
            }
          />

          <TextBoxWrapper
            id="details-popup__success-message"
            className="details-popup__success-message"
            value={successMessage || ""}
            onChange={setSuccessMessage}
            placeholder={translateMessage({
              intl,
              id: "ws_enter_form_success_message",
              defaultMessage: "Enter form success message",
            })}
          />
        </PopupCol>
      </PopupRow>
    </PopupSection>
  );
};
